export const loadStripeScript = () => {
  return new Promise(resolve => {
    if (document.querySelector('script[src="https://js.stripe.com/v3/"]')) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/";
    script.onload = resolve;
    document.body.appendChild(script);
  });
};
